import { dialog } from "../../../../nq-component";
import React, { useState } from "react";
import DialogDate from "./DialogDate";
import { footer } from "framer-motion/m";

function DialogConfirmation({
  user,
  handleAssign,
  object,
  title,
  type,
  onchange,
  handleConfirm,
  onInputDate,
}) {
  const fullName = `${object?.employee?.firstName} ${object?.employee?.lastName}`;
  const [remarks, setRemarks] = useState("");

  const role = user?.roles?.[0]?.id;

  return (
    <>
      <div className="p-4">
        <div className="d-flex flex-column">
          <div className="d-flex gap-3">
            <i
              className="bi bi-question-circle fs-2 px-2 py-1 rounded"
              style={{ backgroundColor: "#F5F5F5", color: "#D18237" }}
            ></i>
            <h5
              className="fw-bold align-self-center"
              style={{ color: "#D18237" }}
            >
              {title}
            </h5>
          </div>
          <div className="d-flex flex-column mx-5">
            {type ? (
              <div className="ms-2 me-1 mt-1">
                <p className="text-muted">
                  Are you sure you want to {type} this resignation?
                </p>
                <div
                  className="mt-2 d-flex border border-1 align-content-center rounded-1 p-3 gap-2 justify-content-center"
                  style={{ backgroundColor: `#DBDBDB` }}
                >
                  <p
                    className="text-muted m-0 text-truncate"
                    style={{ fontSize: `0.8rem` }}
                  >
                    {fullName}
                  </p>

                  <p
                    className="m-0 text-truncate"
                    style={{ fontSize: `0.8rem` }}
                  >
                    (
                    <span style={{ color: `#D18237` }}>
                      {object?.employee?.position}
                    </span>
                    )
                  </p>
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="d-flex flex-column mt-3 w-100">
              <label>
                <b>Remarks</b>
                <span className="text-danger fw-lighter ms-1">*</span>
              </label>
              <div className="ms-2 me-1">
                <textarea
                  className="w-100 rounded-1 p-2"
                  placeholder="Enter remarks here..."
                  style={{
                    fontSize: "0.9rem",
                    maxHeight: "170px",
                    minHeight: "100px",
                  }}
                  onChange={(e) => {
                    onchange(e);
                    setRemarks(e.target.value);
                  }}
                  onInput={(e) => {
                    e.target.style.height = "auto";
                    e.target.style.height = `${Math.min(
                      e.target.scrollHeight,
                      150
                    )}px`;
                  }}
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center mb-3 d-flex justify-content-center gap-2">
        <button
          type="submit"
          className="btn text-white px-5"
          onClick={role === "Admin" ? onInputDate : handleConfirm}
          style={{
            backgroundColor: remarks === "" ? "#d1823775" : "#D18237",
          }}
          disabled={remarks === ""}
        >
          Confirm
        </button>
        <button
          className="btn px-5"
          style={{ backgroundColor: "#e8ecf3" }}
          onClick={() => dialog.close()}
        >
          Cancel
        </button>
      </div>
    </>
  );
}

export default DialogConfirmation;
